import React from 'react'

function Index() {
  return (
    <div></div>
  )
}

export default Index